import { Seo } from "@/components/Seo";
import { Hero } from "@/components/home/Hero";
import { EditorialMarquee } from "@/components/home/Marquee";
import { Approach } from "@/components/home/Approach";
import { FocusGrid } from "@/components/home/FocusGrid";
import { Services } from "@/components/home/Services";
import { Process } from "@/components/home/Process";
import { CtaBand } from "@/components/home/CtaBand";

export default function Home() {
  return (
    <>
      <Seo
        title="Symmori — Influencer Marketing for Informational YouTube"
        description="Symmori connects brands with informational YouTube creators across business, geopolitics, science, technology, education and more. Discuss a campaign."
        path="/"
      />
      <Hero />
      <EditorialMarquee />
      <Approach />
      <FocusGrid />
      <Services />
      <Process />
      <CtaBand />
    </>
  );
}
